module.exports = __webpack_public_path__ + "static/media/r137.0c31120a.jpg";